


































































import { registerEvent, unregisterEvent, AxEventType, emitEvent } from '@aspenware-library/event-hub'
import { Component, Vue, Prop } from 'vue-property-decorator'

import { ProductAdminSettingsInterface } from '../../interfaces/ProductAdminSettings.interface'
import { productSettingsService } from '../../services/ProductSettingsService'

const defaultModel: ProductAdminSettingsInterface = {
  CountCrossSellLightboxShouldShow: 0,
  IsCrossSellLightboxEnabled: false,
  IsGuestCheckoutEnabled: false,
  IsEnhancedCartEnabled: false,
  ShowQRCodeInConfirmationEmail: false,
  InsertQRCodeOnConfirmation: false,
  UseLegacy: false,
  CloudEnabled: false,
  CloudShowMaxPrice: false,
}

@Component
export default class AdminProductSettings extends Vue {
  @Prop() productId: number

  // Data
  private model: ProductAdminSettingsInterface = defaultModel

  // Lifecycle Events
  async created() {
    this.model = await productSettingsService.getProductAdminSettings(this.productId)
  }

  mounted() {
    registerEvent(AxEventType.AdminProductSettingsUpdate, this.consumeUpdateProductSettingsEvent)
  }

  beforeDestroy() {
    unregisterEvent(AxEventType.AddToCart, this.consumeUpdateProductSettingsEvent)
  }

  // Methods
  public async consumeUpdateProductSettingsEvent(): Promise<void> {
    try {
      emitEvent(AxEventType.AdminProductSettingsSaveStatus, 'in-progress')
      this.model = await productSettingsService.updateProductAdminSettings(this.productId, this.model)
      emitEvent(AxEventType.AdminProductSettingsSaveStatus, 'success')
    } catch (e) {
      emitEvent(AxEventType.AdminProductSettingsSaveStatus, 'failed')
    }
  }
}
